import React from 'react';
import { Link } from 'gatsby';
import Bio from '../components/bio';
import Layout from '../components/layout';
import SEO from '../components/seo';

/**
 * String.prototype.replaceAll() polyfill
 * https://gomakethings.com/how-to-replace-a-section-of-a-string-with-another-one-with-vanilla-js/
 * @author Chris Ferdinandi
 * @license MIT
 */
if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function (str, newStr) {
    // If a regex pattern
    if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
      return this.replace(str, newStr);
    } // If a string


    return this.replace(new RegExp(str, 'g'), newStr);
  };
}

function convertNoteFormatting(html) {
  var markup = function markup(id) {
    return "<label for=\"note-" + id + "\" class=\"note-toggle note-marker\"></label><input type=\"checkbox\" id=\"note-" + id + "\"class=\"note-toggle\"/>";
  };

  var regex = /\[>\d+\]/g;
  return html.replaceAll(regex, function (match) {
    return markup(match.slice(2, -1));
  });
}

function BlogPostTemplate(_ref) {
  var _data$site, _data$site$siteMetada, _post$frontmatter, _post$frontmatter2, _post$frontmatter3;

  var data = _ref.data,
      location = _ref.location,
      pageContext = _ref.pageContext;
  var post = data.markdownRemark;
  var blogName = (data === null || data === void 0 ? void 0 : (_data$site = data.site) === null || _data$site === void 0 ? void 0 : (_data$site$siteMetada = _data$site.siteMetadata) === null || _data$site$siteMetada === void 0 ? void 0 : _data$site$siteMetada.blogName) || '';
  var previous = pageContext.previous,
      next = pageContext.next;
  var html = convertNoteFormatting((post === null || post === void 0 ? void 0 : post.html) || '');
  var description = (post === null || post === void 0 ? void 0 : (_post$frontmatter = post.frontmatter) === null || _post$frontmatter === void 0 ? void 0 : _post$frontmatter.description) || (post === null || post === void 0 ? void 0 : post.excerpt) || "A blog post at " + blogName;
  return /*#__PURE__*/React.createElement(Layout, {
    location: location,
    title: blogName
  }, /*#__PURE__*/React.createElement(SEO, {
    title: blogName,
    description: description
  }), /*#__PURE__*/React.createElement("h1", {
    className: "text-cerise-700 text-3xl font-black mt-8 mb-2 text-center"
  }, post === null || post === void 0 ? void 0 : (_post$frontmatter2 = post.frontmatter) === null || _post$frontmatter2 === void 0 ? void 0 : _post$frontmatter2.title), /*#__PURE__*/React.createElement("p", {
    className: "text-ocean-500 text-sm mb-2 text-center"
  }, post === null || post === void 0 ? void 0 : (_post$frontmatter3 = post.frontmatter) === null || _post$frontmatter3 === void 0 ? void 0 : _post$frontmatter3.date), /*#__PURE__*/React.createElement("article", {
    className: "blog-post my-8 md:p-2 lg:text-justify hyphens-manual",
    dangerouslySetInnerHTML: {
      __html: html
    }
  }), /*#__PURE__*/React.createElement(Bio, null), /*#__PURE__*/React.createElement("ul", {
    className: "flex flex-wrap justify-between my-8"
  }, /*#__PURE__*/React.createElement("li", null, previous && /*#__PURE__*/React.createElement(Link, {
    className: "text-cerise-700 text-lg ml-2",
    to: '/blog' + previous.fields.slug,
    rel: "prev"
  }, "\u2190 ", previous.frontmatter.title)), /*#__PURE__*/React.createElement("li", null, next && /*#__PURE__*/React.createElement(Link, {
    className: "text-cerise-700 text-lg mr-2",
    to: '/blog' + next.fields.slug,
    rel: "next"
  }, next.frontmatter.title, " \u2192"))));
}

export default BlogPostTemplate;
var pageQuery = "412779812";